
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletter",
      function () {
        return require("private-next-pages/newsletter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsletter"])
      });
    }
  